module.exports = __webpack_public_path__ + "img/zuja-3.2b2dd5f3.jpg";